import React, { Component } from 'react';
import cx from 'classnames';
import _memoize from 'lodash.memoize';
import Icon from '../../Icon';
import Input from '../../Input';
import { Image } from '../../Image';
import NavigationLink from './NavigationLink';

import Button from '../../Button';
import Dropdown from '../../Dropdown';
import {
  MENU_CONTAINER,
  MENU,
  MENU_EXPANDED_CONTAINER,
  GLOBAL_SEARCH,
  CLOSE_BTN,
  TOP_MENU_LINKS,
  BOTTOM_MENU_LINKS,
  USER_INFO,
  USER_INFO_TEXT,
  GLOBAL_SEARCH_ACTIVE,
  MENU_EXPANDED_HEADER } from
'../styles/navMobileMenu';
import onEnterPressed from '../../../common/utils/onEnterPressed';
import Text from '../../Text';

import '../styles/_nav-menu-mobile.scss';






























export default class NavigationMenuMobile extends Component {
  static defaultProps = {
    isExpandable: true
  };

  constructor(props) {
    super(props);

    this.state = {
      minimised: true,
      searchActive: false,
      subMenuRouteItems: void 0
    };
  }

  onSubmenuClick = _memoize((subMenuRouteItems) => () => {
    this.setState({ subMenuRouteItems });
  });

  toggleMinimiseState = () => {
    this.setState(({ minimised }) => ({
      minimised: !minimised,
      subMenuRouteItems: void 0,
      searchActive: false
    }));
  };

  closeSubMenu = () => {
    this.setState({ subMenuRouteItems: void 0 });
  };

  toggleSearchState = () => {
    this.setState(({ searchActive }) => ({ searchActive: !searchActive }));
  };

  onPrimaryActionChanged = ({ value }) => {
    const { primaryButtonProps } = this.props;

    if (primaryButtonProps && primaryButtonProps.options) {
      const selectedOption = primaryButtonProps.options.
      find((option) => option.value === value);

      if (selectedOption) {
        selectedOption.action();
        this.toggleMinimiseState();
      }
    }
  };

  renderNavLink = (
  {
    label,
    icon,
    url,
    selected,
    active,
    onClick,
    disableMinimiseOnClick,
    className,
    subMenuRoutes,
    withSeparator
  }) =>
  {
    const { history, primaryLinksColour, primaryLinksSelectedColour, roundedItems } = this.props;
    const click = () => {
      if (subMenuRoutes) {return this.onSubmenuClick(subMenuRoutes)();}

      if (!disableMinimiseOnClick) {this.toggleMinimiseState();}

      return onClick ? onClick() : history.push(url);
    };

    return (
      <NavigationLink
        key={url}
        onClick={click}
        label={label}
        selected={selected || active}
        icon={icon}
        className={className}
        linkColour={primaryLinksColour || 'denim'}
        linkHoverColor={primaryLinksSelectedColour}
        linkSelectedColor={primaryLinksSelectedColour}
        hasSubmenu={subMenuRoutes && subMenuRoutes.length}
        withSeparator={withSeparator}
        rounded={roundedItems} />);


  };

  renderSubNavLink = (
  {
    label,
    icon,
    url,
    selected,
    iconColor,
    iconSize
  }) =>
  {
    const { history, roundedItems } = this.props;
    const click = () => {
      this.toggleMinimiseState();

      return history.push(url);
    };

    return (
      <NavigationLink
        key={url}
        onClick={click}
        label={label}
        selected={selected}
        icon={icon}
        selectedColour="greenSnake"
        iconColour={iconColor}
        iconSize={iconSize}
        linkSelectedColor="lightGreen"
        linkColour="denim"
        rounded={roundedItems} />);


  };

  renderSearchIcon() {
    const { searchActive } = this.state;

    return (
      <Icon
        name="search"
        color="black"
        size={20}
        onClick={!searchActive ? this.toggleSearchState : void 0} />);


  }

  renderMinimized = () => {
    const { onNotificationsClick, onSearch, primaryLinksColour } = this.props;
    const { searchActive } = this.state;

    return (
      <div className={cx('nav-menu-mobile__header', MENU)}>
        <Icon
          name="alignjustified"
          color={primaryLinksColour || 'darkdenim'}
          onClick={this.toggleMinimiseState} />

        {
        onSearch ?

        <Input
          id="global-search"
          prefix={this.renderSearchIcon()}
          styleType="TEXT"
          className={cx(GLOBAL_SEARCH, searchActive ? GLOBAL_SEARCH_ACTIVE : void 0)}
          onChange={onSearch}
          placeholder="Search"
          suffixIcon={searchActive ?
          <Icon
            name="close"
            color="regent"
            size={10}
            onClick={this.toggleSearchState} /> :

          null} /> :


        null}

        <Icon
          name="notifications"
          onClick={onNotificationsClick}
          color={primaryLinksColour || 'darkdenim'}
          size={20} />

      </div>);

  };

  renderExpanded = () => {
    const {
      topRoutes,
      bottomRoutes,
      user,
      primaryButtonProps,
      primaryLinksColour
    } = this.props;
    const { minimised, subMenuRouteItems } = this.state;

    return (
      <div className={cx('nav-menu-mobile__menu', MENU_EXPANDED_CONTAINER(minimised))}>
        <div className={cx('nav-menu-mobile__menu__header', MENU_EXPANDED_HEADER)}>
          <Icon
            className={CLOSE_BTN}
            name="close"
            size={16}
            color={primaryLinksColour || 'darkdenim'}
            onClick={this.toggleMinimiseState}
            onKeyDown={onEnterPressed({ onClick: this.toggleMinimiseState })}
            {...subMenuRouteItems ? {
              name: 'returnI',
              onClick: this.closeSubMenu,
              onKeyDown: onEnterPressed({ onClick: this.closeSubMenu })
            } : {}} />

        </div>
        {
        user && !subMenuRouteItems &&
        <div className={USER_INFO({ primaryLinksColour })}>
              <Image
            imageUrl={user.imageUrl}
            defaultImageIcon="user"
            defaultIconColour="russian"
            height="40px"
            width="40px"
            onClick={user.onUserClick}
            circular />

              <div className={USER_INFO_TEXT}>
                <Text button noMargin>{user.fullName}</Text>
                <Text caption noMargin>{user.role}</Text>
              </div>
            </div>}


        {
        primaryButtonProps && !primaryButtonProps.isDropdownButton && !subMenuRouteItems ?

        <Button
          {...primaryButtonProps}
          onClick={() => {
            if (primaryButtonProps.onClick) primaryButtonProps.onClick();
            this.toggleMinimiseState();
          }}
          type="TERTIARY"
          prefix="addfat"
          prefixSize={15} /> :

        null}

        {
        primaryButtonProps && primaryButtonProps.isDropdownButton && !subMenuRouteItems ?

        <Dropdown
          isExpandIconVisible={false}
          type="BUTTON"
          onChange={this.onPrimaryActionChanged}
          value={{
            label: primaryButtonProps.label,
            value: 'default',
            prefix: primaryButtonProps.prefix || '',
            prefixSize: 20
          }}
          options={primaryButtonProps.options ?
          primaryButtonProps.options.map((option) => ({
            label: option.label,
            value: option.value,
            prefix: option.prefix,
            prefixSize: 15
          })) :
          []}

          menuWidth={200} /> :

        null}

        {
        !subMenuRouteItems ?
        <>
              <div className={cx('nav-menu-mobile__menu__links', TOP_MENU_LINKS)}>
                {topRoutes.map(this.renderNavLink)}
              </div>
              {
          bottomRoutes &&
          <div className={cx('nav-menu-mobile__menu__links', BOTTOM_MENU_LINKS)}>
                    {bottomRoutes.map(this.renderNavLink)}
                  </div>}


            </> :

        <div className={cx('nav-menu-mobile__menu__links', TOP_MENU_LINKS)}>
              {subMenuRouteItems.map(this.renderSubNavLink)}
            </div>}


      </div>);

  };

  render() {
    const { primaryColour } = this.props;

    return (
      <div className={cx('nav-menu-mobile', MENU_CONTAINER(primaryColour))}>
        {this.renderMinimized()}
        {this.renderExpanded()}
      </div>);

  }
}